import Box, { BoxProps } from "@govlaunch/web/src/box/Box";
import { Heading, Text } from "@govlaunch/web";
import React from "react";
import { IStoryFieldsFragment } from "../fragments/__generated__/StoryFieldsFragment.generated";

interface IStoryHeaderProps extends BoxProps {
  story: Pick<IStoryFieldsFragment, "author" | "title" | "introduction" | "tags" | "government" | "locations">;
  headerRef?: (node: any) => void;
}

export default function StoryHeader({ story, headerRef, ...props }: IStoryHeaderProps) {
  return (
    <Box {...props} id="test">
      <h1 css={{ fontSize: "40px !important", fontWeight: 700, color: "#086BE5" }} ref={headerRef}>
        {story.title}
      </h1>
      {story.introduction && (
        <Text mt={2} css={{ fontSize: "20px !important", fontWeight: 400 }}>
          {story.introduction}
        </Text>
      )}
    </Box>
  );
}
